import { ActivateAccountPage as SharedActivateAccountPage } from "@retro-ia/shared/pages";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import logo from "@/assets/LOGO-RETRO-IA.png";

export function ActivateAccountPage() {
  return <SharedActivateAccountPage logo={logo} themeToggle={<ThemeToggle />} />;
}
